import React, { Component } from "react";
import Layout from "layouts/DashboardManage";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import SubmitButton from "components/Forms/Buttons/Submit";
import Notification, { notifyApiError } from "components/Notification";
import { getAllClients, addClient } from "store/actions/clientAction";
import Textbox from "components/Forms/Elements/Textbox";
import AutoSuggest from "components/Forms/Elements/AutoSuggest";
import hasProperty from "lodash/has";
import Translate from "helpers/Translate";

export class Add extends Component {
  state = {
    name: "",
    clientId: ""
  };

  componentDidMount() {
    this.props.getAllClients({});
  }

  componentDidUpdate(prevProps) {
    // When the new client is created successfully, we will redirect to step 2
    if (
      prevProps.addClientResponse !== this.props.addClientResponse &&
      hasProperty(this, "props.addClientResponse.id")
    ) {
      // Redirect to index page
      this.props.history.push(`/manage/clients`);
    }

    // When there was a problem creating the new client
    if (
      prevProps.errorClient !== this.props.errorClient &&
      this.props.errorClient &&
      Object.keys(this.props.errorClient).length > 0
    ) {
      notifyApiError(this.props.errorClient);
    }
  }

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleCreate = () => {
    this.props.addClient({
      name: this.state.name
    });
  };

  handleUpdate = e => {
    e.preventDefault();
    if (!this.state.clientId) {
      Notification.error(
        Translate({ id: "please_select_a_valid_client_first" })
      );
    } else {
      // Redirect to Edit Page
      this.props.history.push(`/manage/clients/edit/${this.state.clientId}`);
    }
  };

  render() {
    return (
      <Layout>
        <div className="add-edit-client">
          <h1 className="title mb-30">
            {Translate({ id: "add_edit_client" })}{" "}
          </h1>
          <div className="tabs">
            <div className="tab tab-manage selected">
              {Translate({ id: "step_1_manage_client" })}
            </div>
            <div className="tab tab-design selected1">
              {Translate({ id: "step_2_update_client_details" })}
            </div>
          </div>

          <div className="tab-wrapper">
            <div className="tab-manage-wrapper selected">
              <div className="new">
                <h2 className="title mb-30">
                  {Translate({ id: "create_a_new_client" })}{" "}
                </h2>
                <div className="input-wrapper mb-20">
                  <label htmlFor="name">
                    {Translate({ id: "new_client_name" })}{" "}
                  </label>
                  <Textbox
                    type="text"
                    placeholder="Abc Inc."
                    id="name"
                    name="name"
                    fieldValue={this.state.name}
                    onChange={this.handleChange}
                    onReturnKey={this.handleCreate}
                    errors={this.props.errorClient}
                    errorKey="name"
                    formErrorClass="form-error-inverse"
                  />
                </div>
                <SubmitButton
                  className="btn btn-default-light btn-tools center"
                  buttonIconClass="fas fa-save"
                  buttonText={Translate({ id: "save_and_next" })}
                  btnId="create"
                  isLoading={this.props.isLoading}
                  handleSubmit={this.handleCreate}
                />
              </div>

              <div className="divider">
                <span>{Translate({ id: "or", uppercase: true })} </span>
              </div>

              <div className="update">
                <h2 className="title mb-30">
                  {Translate({ id: "edit_existing_client" })}{" "}
                </h2>

                <div className="input-wrapper mb-20">
                  <label htmlFor="autosuggest">
                    {Translate({ id: "type_to_search_for_a_client" })}
                  </label>
                  <AutoSuggest
                    data={
                      hasProperty(this, "props.getAllClientsResponse.data")
                        ? this.props.getAllClientsResponse.data
                        : []
                    }
                    keyword={value => {
                      this.props.getAllClients({ name: value });
                      this.setState({ clientId: "" });
                    }}
                    displayItemInList="name"
                    onSelect={selectedItem =>
                      this.setState({ clientId: selectedItem.id })
                    }
                  />
                </div>
                <SubmitButton
                  className="btn btn-default-light btn-tools center"
                  buttonIconClass="fas fa-arrow-circle-right"
                  buttonText={Translate({ id: "next" })}
                  btnId="update"
                  handleSubmit={this.handleUpdate}
                />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

Add.propTypes = {
  getAllClients: PropTypes.func.isRequired,
  addClient: PropTypes.func.isRequired,
  client: PropTypes.object,
  isLoading: PropTypes.bool,
  getAllClientsResponse: PropTypes.object,
  addClientResponse: PropTypes.object,
  errorClient: PropTypes.object
};

const mapStateToProps = state => {
  return {
    getAllClientsResponse: state.client.getAllClients,
    addClientResponse: state.client.addClient,
    errorClient: state.client.errorClient,
    isLoading: state.client.isLoadingClient
  };
};

export default connect(mapStateToProps, { getAllClients, addClient })(Add);
